export default function reverse(){
	return function(array){
		return array?.reverse();
	}
}
